const truncate = (text, maxLength) => {
  const excerpt = text.slice(0, maxLength);
  const lastSpaceIndex = excerpt.lastIndexOf(' ');
  const trimmedExcerpt = excerpt.slice(0, lastSpaceIndex);

  return `${trimmedExcerpt}...`;
};

export default truncate;
